import { render, staticRenderFns } from "./NeighborhoodData.vue?vue&type=template&id=5017ead1&"
import script from "./NeighborhoodData.vue?vue&type=script&lang=js&"
export * from "./NeighborhoodData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports